import { connect } from 'react-redux';
import DailySidePanel from '../../../components/DailyPlanning/DailySidePanel/DailySidePanel';
import { selectDateAndUpdateReload } from '../../../actions/areas/dailyPlanning';
import { selectSelectedDate } from '../../../reducers/areas/dailyPlanning';

const mapStateToProps = state => ({
  selectedDate: selectSelectedDate(state),
});

const mapDispatchToProps = dispatch => ({
  changeDate: date => dispatch(selectDateAndUpdateReload(date)),
});

const DailyCalendarSidePanel = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DailySidePanel);

export default DailyCalendarSidePanel;
